<template>
    <div role="table" class="board-table board-table--view mb-12">
        <div role="rowgroup">
            <div role="row">
                <div role="columnheader">
                    <v-row>
                        <v-col cols="auto">[{{ category }}] {{ program.title }}</v-col>
                        <v-spacer />
                        <v-col cols="auto">
                            <v-btn color="primary" outlined elevation="0" @click="showContent = !showContent">{{ showContent ? "닫기" : "상세보기" }}</v-btn>
                        </v-col>
                    </v-row>
                </div>
            </div>
            <div role="row">
                <div role="cell">
                    <ul class="board-view-data">
                        <li>
                            신청기간 : <span class="d-inline-block">{{ applicationDuration }}</span>
                        </li>
                        <li>
                            지원기간 : <span class="d-inline-block">{{ serviceDuration }}</span>
                        </li>
                    </ul>
                </div>
            </div>
            <div role="row" v-if="showContent">
                <div role="cell">
                    <div class="board-content">
                        <div v-html="program.content"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import dayjs from "dayjs";
import { SERVICE_PROGRAM_CATEGORIES } from "@/assets/variables";

export default {
    props: ["program"],
    computed: {
        category() {
            return SERVICE_PROGRAM_CATEGORIES[this.program.category]?.text;
        },

        applicationDuration() {
            const { applicationStartsAt, applicationEndsAt } = this.program;

            if (applicationStartsAt && applicationEndsAt) {
                const startsAt = dayjs(applicationStartsAt).format("YYYY.MM.DD");
                const endsAt = dayjs(applicationEndsAt).format("YYYY.MM.DD");

                return `${startsAt} - ${endsAt}`;
            } else return "-";
        },
        serviceDuration() {
            const { serviceStartsAt, serviceEndsAt } = this.program;

            if (serviceStartsAt && serviceEndsAt) {
                const startsAt = dayjs(serviceStartsAt).format("YYYY.MM.DD");
                const endsAt = dayjs(serviceEndsAt).format("YYYY.MM.DD");

                return `${startsAt} - ${endsAt}`;
            } else return "-";
        },
    },
    data() {
        return { showContent: false };
    },
};
</script>

<style></style>
